"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameModes = void 0;
const Language_1 = require("../../lang/Language");
class GameModes {
    static isDefault(s) {
        return s.tag === 'default';
    }
    static isTournament(s) {
        return s.tag === 'tournament';
    }
    static returnMode(s) {
        return s === 'tournament' ? this.Tournament : this.Default;
    }
}
exports.GameModes = GameModes;
GameModes.Default = {
    tag: 'default',
    description: Language_1.Language.strings.states.game.default,
};
GameModes.Tournament = {
    tag: 'tournament',
    description: Language_1.Language.strings.states.game.tournament,
};
//# sourceMappingURL=GameMode.js.map